import Image from "next/image";

interface AbsenModalProps {
  isOpen: boolean;
  jenis?: string;
  onClose: () => void;
  onSelect: (type: "dalam" | "luar") => void;
}

const AbsenModal: React.FC<AbsenModalProps> = ({ isOpen, onSelect, jenis }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-end justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-t-lg shadow-lg w-full max-w-sm">
        <Image
          src="/ic_lokasi_absen.svg"
          alt="Lokasi Absen"
          width={240}
          height={240}
          className="mx-auto mb-4"
        />
        <h2 className="text-lg font-bold mb-4 text-center">
          Konfirmasi Lokasi Absen
        </h2>
        <h3 className="text-center mb-4">
          Dimana kamu melakukan Absen {jenis || "Masuk"}
        </h3>
        <div className="flex flex-col items-center space-y-2">
          {/* Centering the buttons */}
          <button
            className="bg-[#B90101] text-white px-4 py-2 rounded-2xl w-full"
            onClick={() => onSelect("dalam")}
          >
            Absen di Dalam
          </button>
          <button
            className="bg-[#550003] text-white px-4 py-2 rounded-2xl w-full"
            onClick={() => onSelect("luar")}
          >
            Absen di Luar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AbsenModal;
